"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POReplacePrompt = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_button_1 = require("@ryerson/frontend.button");

var BarcodeResultsContent_1 = require("./BarcodeResultsContent");

var frontend_application_1 = require("@ryerson/frontend.application");

var POReplacePrompt = function POReplacePrompt(_ref) {
  var _ref$itemSearchParams = _ref.itemSearchParams,
      item = _ref$itemSearchParams.item,
      urlSearchParams = _ref$itemSearchParams.urlSearchParams,
      goToStore = _ref.goToStore;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var darkGray = theme.colors.primary.darkGray;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      language = _ref3.localization.language;

  var content = BarcodeResultsContent_1.BarcodeResultsContent[language] || BarcodeResultsContent_1.BarcodeResultsContent.en;
  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
    children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      size: "md",
      color: darkGray,
      children: content.poReplacePrompt
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      direction: "column",
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        css: {
          marginTop: "24px"
        },
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          label: content.poReplaceYes,
          type: "primary",
          size: "md",
          onClick: function onClick() {
            return goToStore(item, {
              urlSearchParams: urlSearchParams,
              replacePO: true
            });
          },
          paddingType: "relaxed",
          fullwidth: true
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        css: {
          marginTop: "24px"
        },
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          label: content.poReplaceNo,
          type: "secondary",
          size: "md",
          background: darkGray,
          foreground: "light",
          onClick: function onClick() {
            return goToStore(item, {
              urlSearchParams: urlSearchParams,
              replacePO: false
            });
          },
          paddingType: "relaxed",
          fullwidth: true
        })
      })]
    })]
  });
};

exports.POReplacePrompt = POReplacePrompt;